import { render, staticRenderFns } from "./SetStatusModal.vue?vue&type=template&id=2e1411e2&scoped=true&"
import script from "./SetStatusModal.vue?vue&type=script&lang=js&"
export * from "./SetStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./SetStatusModal.vue?vue&type=style&index=0&id=2e1411e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1411e2",
  null
  
)

export default component.exports